import { Box, Button, HStack, Text } from '@chakra-ui/react';

import Modal from '../Modal/Modal';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStay: () => void;
  onDiscard: () => void;
}

const UnsavedChangesModal = ({ isOpen, onClose, onStay, onDiscard }: UnsavedChangesModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="You have unsaved changes"
      footer={
        <HStack gap={3} justifyContent="flex-end" w="100%">
          <Button
            variant="outline"
            onClick={onStay}
            px={4}
            py={2}
            fontSize={14}
            fontWeight={500}
            color="fg"
            borderColor="gray.300"
            _hover={{ backgroundColor: 'gray.50' }}
          >
            Stay & Continue Editing
          </Button>
          <Button
            variant="solid"
            onClick={onDiscard}
            px={4}
            py={2}
            fontSize={14}
            fontWeight={500}
            backgroundColor="orange.500"
            color="white"
            _hover={{ backgroundColor: 'orange.600' }}
          >
            Discard Changes
          </Button>
        </HStack>
      }
    >
      <Box pb={4}>
        <Text fontSize={14} color="fg.muted" fontWeight={400}>
          You edited the current Config but haven't saved it yet. If you switch to another Config, all unsaved
          changes will be lost.
        </Text>
      </Box>
    </Modal>
  );
};

export default UnsavedChangesModal;